/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { SpeakingControls } from "../components/SpeakControls";
import { useMobileView } from "../components/MobileViewContext";
import SpeakFooter from "./SpeakFooter";
import { isSPEAKABC } from "../../libs/env";

const SpeakStartPage = ({
  section,
  exercise,
  systemrequirementToggle,
  setIsonRecorder,
  isStopTimer,
  setresetAudio,
  answers,
  section_id,
  page_id,
  data,
  testStatus,
  isSubmitting,
}) => {
  let {isMobileView} = useMobileView();

  return (
    <>
      <div
        key={exercise.id}
        className={`d-flex flex-column ${
          isMobileView ? "sm-Speak-Quizbody" : "Speak-Quizbody"
        }`}
      >
         <div className="d-flex flex-column main-content container speak-content-width">
        <div className="flex-container">
          <h3 class="custom-heading">{section.section_name}</h3>
        </div>
        <p class="regular-text py-3">{exercise.prompt_content}</p>
        <div class="photo-description justify-content-center border overflow-auto custom_scroll">
          <div
            spellcheck="false"
            data-gramm="false"
            dangerouslySetInnerHTML={{
              __html: `${exercise.html_content
                ?.replace(/\[\[.*?\]\]\.\s*/g, "")
                .replace(/\[\[.*?\]\]\s*/g, "")}`,
            }}
          />
        </div>
        <div key={`${section.id}${exercise.id}`}>
          <SpeakingControls
            systemrequirementToggle={systemrequirementToggle}
            isStopTimer={isStopTimer}
            setIsonRecorder={setIsonRecorder}
            data_section_id={section_id}
            data_page_id={page_id}
            answers={answers}
            setresetAudio={setresetAudio}
            data_exercise_id={exercise.id}
            data_type={data.type}
            Studentname={data.school_student_id}
            testStatus={testStatus}
            isSubmitting={isSubmitting}
          />
        </div>
        </div>
        {!isSPEAKABC && (
        <div className={isMobileView ? ("col-12 sm-footer-bottom") : "col-10 sm-footer-bottom"}>
          <SpeakFooter />
        </div>
        )}
      </div>
    </>
  );
};

export default SpeakStartPage;
